/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('amazonRedshiftSourceEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./amazon-redshift-source-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
